import axios from 'axios'
import qs from "qs"
import { clone, removeEmpty } from '@/util/libUtil.js'
import readError from '../util.js'

const state = () => ({
    isOpenDialog: false,
    isEditableForm: false,
    formType: '',
    editingId: '',
    Name: '',
    Permanence: '',
    Image: '',
    // Brand: null,
    Operator: '',
    SelectedPromotions: [],
    price_history: [],
    upfront_history: [],
    IsActive: false,
    Price: '',
    Upfront: 0,
    FamiliaObjetivo: '',
    SelectedSegment: '',
    SVAManagement: {
        svas: [],
        totalEntries: 0,
        isLoading: false,
        page: 1,
        params: {},
        default: 0
    },
    isLoading: false,
    paths: {
        svaPath: '/api/servicios/sva/',
    }
})

const initialState = { ...state() }

const mutations = {
    resetStore: (state) => {
        let copy = [...state.sva]
        initialState.sva = copy
        Object.assign(state, initialState)
    },
    SVAManagementPage: (state, val) => {
        state.SVAManagement.page = val;
    },
    SVAManagementTarrifs: (state, val) => {
        state.SVAManagement.svas = clone(val);
    },
    SVAManagementParams(state, val) {
        state.SVAManagement.params = val
    },
    SVAManagementIsLoading(state, val) {
        state.SVAManagement.isLoading = val
    },
    SVAManagement(state, val) {
        state.SVAManagement.totalEntries = val.count
        state.SVAManagement.svas = val.results
    },
    price_history: (state, val) => {
        state.price_history = clone(val);
    },
    upfront_history: (state, val) => {
        state.upfront_history = clone(val);
    },
    SelectedPromotions: (state, val) => {
        state.SelectedPromotions = val;
    },
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    Name: (state, val) => {
        state.Name = val
    },
    // Brand: (state, val) => {
    //     state.Brand = val
    // },
    Operator: (state, val) => {
        state.Operator = val
    },
    Permanence: (state, val) => {
        state.Permanence = val
    },
    Price: (state, val) => {
        state.Price = val
    },
    Upfront: (state, val) => {
        state.Upfront = val
    },
    FamiliaObjetivo: (state, val) => {
        state.FamiliaObjetivo = val
    },
    SelectedSegment: (state, val) => {
        state.SelectedSegment = val
    },
    Image: (state, val) => {
        state.Image = val
    },
    more_info: (state, val) => {
        state.more_info = val
    },
    IsActive: (state, val) => {
        state.IsActive = val
    },
    // sva: (state, val) => {
    //     state.sva = clone(val)
    // },
    isLoading: (state, val) => {
        state.isLoading = val
    }
}

const actions = {
    async updateSVAManagementParams({ commit, state }, params) {
        let newParams = { ...state.SVAManagement.params, ...params }
        newParams = removeEmpty(newParams) // eliminate nulls
        commit('SVAManagementParams', newParams)
    },
    async getSVA({ dispatch, getters, rootGetters, state, commit }) {
        try {
            commit('SVAManagementIsLoading', true)
            commit('ManagementBase/loadingItems', true, { root: true })
            let params = clone(state.SVAManagement.params);
            
            if(!'itemsPerPage' in params || !params['itemsPerPage']){
                params['itemsPerPage'] = rootGetters['ManagementBase/itemsPerPage']
            }
            
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.svaPath), {
                params: params,
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                },
            })
            commit('SVAManagement', resp.data)
            commit('SVAManagementIsLoading', false)
            commit('ManagementBase/loadingItems', false, { root: true })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'SVA cargados correctamente'
            }, { root: true })
        } catch (error){
            let read = readError.readError(error)

            if('detail' in read && read.detail == 'Página inválida.'){
                dispatch('updateSVAManagementParams', { page: 1 })
                dispatch('getSVA')
            }else{
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: 'No se pudo cargar el contenido de SVA'
                }, { root: true })
            }
        }
    },
    async delete({ state, dispatch, getters }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.svaPath) + item.id)
            dispatch('getSVA')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    async addSva({ state, getters, dispatch }) {
        // state.FamiliaObjetivo = state.FamiliaObjetivo.map(({ nombre }) => nombre)

        let sva = {
            'name': state.Name,
            'price_value': state.Price,
            'image': "",
            'more_info': "",
            'permanence': state.Permanence,
            // 'brand': state.Brand,
            'is_active': state.IsActive,
            'operator': state.Operator,
            'segment': state.SelectedSegment,
            'promotions': state.SelectedPromotions,
        }

        try {
            await axios.post(getters.getEndpointFromPath(state.paths.svaPath), sva)
            dispatch('getSVA')
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Tarifa añadida correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al añadir sva',
            }, { root: true })
        }
    },
    async editSva({ state, getters, dispatch }) {
        // state.FamiliaObjetivo = state.FamiliaObjetivo.map(({ nombre }) => nombre)


        let sva = {
            'name': state.Name,
            // 'price': state.Price,
            'image': state.Image,
            'more_info': state.more_info,
            'permanence': state.Permanence,
            // 'brand': state.Brand,
            'is_active': state.IsActive,
            'operator': state.Operator,
            'segment': state.SelectedSegment,
            'promotions': state.SelectedPromotions,
        }

        try {
            await axios.put(getters.getEndpointFromPath(state.paths.svaPath) + state.editingId + '/', sva)
            dispatch('getSVA')
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'SVA editada correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al editar tarifa',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}